import axios from 'axios'
import { CMSApiResponseBody } from 'types/cms/request'
import { Language } from 'types/language'
import { stringify } from 'qs'

import { CmsJobOffer } from 'types/cms/collection-types'

/**
 * Get the job offer by slug from the CMS
 *
 * @param {string} slug
 * @param {Language} locale
 * @returns {Promise<CmsJobOffer | undefined>}
 */
const getJobOfferBySlug = async (slug: string, locale: Language = Language.DUTCH): Promise<CmsJobOffer | undefined> => {
  try {
    const query = stringify({
      locale
    })

    const {
      data: { data }
    } = await axios.get<CMSApiResponseBody<CmsJobOffer>>(`${process.env.CMS_API_URL}/job-offer/${slug}?${query}`)

    return data
  } catch (_) {
    return undefined
  }
}

export default getJobOfferBySlug
